import React from "react";
import css from "./index.module.scss";
import thumbnail from "../../../re_redesigned_componnents/asset/login_bg.webp";
import LinearProgress, { linearProgressClasses } from '@mui/material/LinearProgress';
import { styled } from '@mui/material/styles';
const BorderLinearProgress = styled(LinearProgress)(({ theme }) => ({
  height:6,
  borderRadius: 5,
  [`&.${linearProgressClasses.colorPrimary}`]: {
    backgroundColor: theme.palette.grey[200],
    ...theme.applyStyles('dark', {
      backgroundColor: theme.palette.grey[800],
    }),
  },
  [`& .${linearProgressClasses.bar}`]: {
    borderRadius: 5,
    backgroundColor: '#390089',
    ...theme.applyStyles('dark', {
      backgroundColor: '#1f0eb8',
    }),
  },
}));




function AssessmentCard() {
  return (
    <div className={css.wrap}>
      <div className={css.thumbnail}>
        <img src={thumbnail} />
      </div>
      <div className={css.content}>
        <div className={css.item}>
          <h4 className={css.title}>Course Name</h4>
          <p>type of game make y =ou question our reality</p>
        </div>

        <div className={css.item}>
          <h4>Subject</h4>
          <p>Psychology</p>
        </div>
        <div className={css.item}>
          <h4>Class/Batch</h4>
          <p>Psychology</p>
        </div>
        <div className={css.item}>
          <h4>Progress</h4>
          <span> <BorderLinearProgress variant="determinate" value={50} /><p>50%</p></span>
         
        </div>
      </div>
    </div>
  );
}

export default AssessmentCard;
